<template>
  <div id="thisism" class="container">

    <app-navigation></app-navigation>

    <div class="ten columns offset-by-one">


      <p>
        2010年末、｢自分達で何かしなくてはいけない｣という曖昧な危機感を覚える。そして｢ビデオカメラとMacがあるから映像をやろう｣という結論に至る。
        またその当時、ふと手に取った本が｢～主義｣/｢～ism｣をまとめた内容であったことから｢ism｣に着想し、見栄えの良さと唯一の組み合わせを探して、｢This-ism｣転じて｢Thisism (ディスイズム)｣を活動名とする。
        手始めに友人のニートが働くまでを撮り、荒編集した内容をYOUTUBEへ公開する。身内からの小さな反響にほくそ笑む。
      </p>

      <p>
        その後、ドキュメントと実験的な動画を軸に作品を作っていこうと息巻く。しかし、特に何かあるわけでもなく腐る。
        それと同じくして｢ビデオ出来るなら何かやってよ｣という軽いノリで、少しづつバンド関連の動画を作ることが増え始める。
        当初はバンドをやっている友達が多かったことから、持ち前のひねくれ性でバンド関連の動画は避けていたものの、話が少しずつ増えるに連れて喜びを感じ、欲求が増していく...というよりは素直になる。
        大きく気持ちを揺り動かしてくれたのはメンバーが身近にいたA PAGE OF PUNKとTHINK AGAINの存在だったと思う。
      </p>

      <p>
        素直なれたので｢もっとやろう｣という思いで今に至る。
      </p>

    </div>
  </div>
</template>
<script>
  import Navigation from './Navigation.vue'

  export default {
    data () {
      return {}
    },
    components: {
      appNavigation: Navigation
    }
  }
</script>
<style lang="scss" scoped>

  .columns {
    padding: 40px 0;
  }
</style>



// WEBPACK FOOTER //
// Thisism.vue?2617c4d0